module.exports = __webpack_public_path__ + "static/media/599.7554(8).7166a780.pdf";